var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18764_30621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5L11 1",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 11L2.5 9.5",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.15002 10.15C3.2615 10.2619 3.39397 10.3506 3.53983 10.4112C3.6857 10.4718 3.84208 10.5029 4.00002 10.5029C4.15795 10.5029 4.31434 10.4718 4.4602 10.4112C4.60606 10.3506 4.73853 10.2619 4.85002 10.15L6.00002 9L3.00002 6L1.85002 7.15C1.73814 7.26148 1.64938 7.39396 1.58881 7.53982C1.52825 7.68568 1.49707 7.84206 1.49707 8C1.49707 8.15794 1.52825 8.31432 1.58881 8.46018C1.64938 8.60604 1.73814 8.73852 1.85002 8.85L3.15002 10.15Z",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.75L5 5.5",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25L6.5 7",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 3.00002L9 6.00002L10.15 4.85002C10.2619 4.73853 10.3506 4.60606 10.4112 4.4602C10.4718 4.31434 10.5029 4.15795 10.5029 4.00002C10.5029 3.84208 10.4718 3.6857 10.4112 3.53983C10.3506 3.39397 10.2619 3.2615 10.15 3.15002L8.85 1.85002C8.73852 1.73814 8.60604 1.64938 8.46018 1.58881C8.31432 1.52825 8.15794 1.49707 8 1.49707C7.84206 1.49707 7.68568 1.52825 7.53982 1.58881C7.39396 1.64938 7.26148 1.73814 7.15 1.85002L6 3.00002Z",
    stroke: "#4A5565",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18764_30621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.64bcc633e95c0e745f43e1fe5aa0d096.svg";
export { ForwardRef as ReactComponent };